/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import LoadingAnimation from '@g17eco/atoms/loading-animation';

const LoadingBar = () => {
  return <div className='onboarding-form'>
    <aside className='title-container'>
      <div className='h1 mb-3'>Welcome!</div>
      <div className='h4 text-strong mb-3'>Setting up your account...</div>
    </aside>
    <section className='loadingBar-container'>
      <LoadingAnimation />
    </section>
  </div>
}

export default LoadingBar;
